import { InjectionToken } from '@angular/core';

export const INTERNAL_SERVER_ERROR_PAGE_ROUTE = new InjectionToken<string>('Internal Server Error Page Route');
export const FORBIDDEN_PAGE_ROUTE = new InjectionToken<string>('Forbidden Page Route');
export const SESSION_EXPIRE_PAGE_ROUTE = new InjectionToken<string>('Session Expire Page Route');
